var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{class:{'text-bold': _vm.bold},domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }